import { LoadingButton } from '@mui/lab'
import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { InputField, ValidationType } from '../../../components/InputField'
import { useSnackbarContext } from '../../../hooks/useSnackBar'
import { useWorkspaceContext } from '../../../hooks/useWorkspace'
import { ReactComponent as LeafIcon } from '../../../icons/icon_leaf.svg'

export interface IError {
  response: {
    data: {
      message: string
    }
  }
}

export default function () {
  const [workspaceName, setWorkspaceName] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const { openSnackBar } = useSnackbarContext()
  const { addWorkspace, setIsCreateWorkspaceModal, setIsCreateAdditionalWorkspaceModal } = useWorkspaceContext()

  const navigate = useNavigate()

  const onAddWorkspace = async () => {
    try {
      setIsLoading(true)
      const { _id, type } = await addWorkspace({ name: workspaceName })
      setIsLoading(false)
      setIsCreateWorkspaceModal(false)
      setIsCreateAdditionalWorkspaceModal(false)
      openSnackBar({
        type: 'success',
        message: 'Workspace created',
      })
      if (type === 'private') {
        navigate(`/${_id}`)
      } else {
        navigate(`/${_id}/tier-selection`)
      }
    } catch (error) {
      setIsLoading(false)
      const errorMessage = (error as IError)?.response?.data?.message || 'Something went wrong!'
      openSnackBar({
        type: 'error',
        message: errorMessage,
      })
      localStorage.removeItem('invite_owner')
    }
  }

  return (
    <Box sx={{ paddingTop: 5.25, paddingX: 6.25, paddingBottom: 4, textAlign: 'center' }}>
      <LeafIcon />

      <Typography variant="h1" color="primary.800" mt={2} mb={1}>
        Create a Workspace
      </Typography>

      <Typography variant="body1" color="grey.500" mb={4}>
        Your workspace is where your projects are located, and where you can invite your team to collaborate.
      </Typography>

      <Box sx={{ width: '320px', margin: '0 auto' }}>
        <InputField
          mb="0px"
          variant="outlined"
          name="workspaceName"
          placeholder="Organization workspace"
          value={workspaceName}
          onChange={(ev) => setWorkspaceName(ev.target.value)}
          validations={[
            {
              type: ValidationType.required,
              params: ['Please enter a workspace name'],
            },
            {
              type: ValidationType.max,
              params: [100, 'Workspace name should not exceed 100 characters'],
            },
            {
              type: ValidationType.matches,
              params: [
                /^[a-zA-Z0-9\s'-]+$/,
                "Workspace name can only contain letters, numbers, spaces, hyphens ( - ) and apostrophes ( ' )",
              ],
            },
          ]}
        />

        <LoadingButton
          onClick={onAddWorkspace}
          variant="contained"
          disabled={!workspaceName || workspaceName.length > 100}
          loading={isLoading}
          sx={{
            width: '100%',
            marginTop: 3.5,
          }}
        >
          Create workspace
        </LoadingButton>
      </Box>
    </Box>
  )
}
